import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mb-32" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "list-container" }
const _hoisted_5 = { class: "mb-8 text-primary" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "mb-0 me-12" }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = { class: "item d-flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-done ms-8",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "mt-24"
}
const _hoisted_12 = { class: "mb-8 text-primary" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "mb-0 me-12" }
const _hoisted_15 = ["aria-label"]
const _hoisted_16 = { class: "item d-flex align-items-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-done ms-8",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-done me-8" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_title = _resolveComponent("modal-title")!
  const _component_modal_header = _resolveComponent("modal-header")!
  const _component_v_loader = _resolveComponent("v-loader")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_modal_body = _resolveComponent("modal-body")!
  const _component_modal_footer = _resolveComponent("modal-footer")!
  const _component_v_modal = _resolveComponent("v-modal")!

  return (_openBlock(), _createBlock(_component_v_modal, {
    size: "lg",
    "class-name": "modal-fullscreen-lg-down"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_modal_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_modal_title, { as: "h4" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Resultados de la anamnesis')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_modal_body, null, {
        default: _withCtx(() => [
          (!_ctx.anamnesisResults.length)
            ? (_openBlock(), _createBlock(_component_v_loader, { key: 0 }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_1, _toDisplayString(// eslint-disable-next-line max-len
            _ctx.$t('¡Enhorabuena! El cuestionario de la anamnesis ha concluido. Según los datos aportados en esta anamnesis, el programa te muestra las siguientes sugerencias:')), 1),
                _createElementVNode("div", _hoisted_2, [
                  (_ctx.alerts.length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.alerts, (alert) => {
                        return (_openBlock(), _createBlock(_component_v_alert, {
                          variant: "warning",
                          role: "alert",
                          key: alert
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(alert), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t('No hay ninguna sugerencia.')), 1))
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('Protocolos y fases disponibles:')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.anamnesisResults, (phase) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "container-item d-flex justify-content-between align-items-center text-primary py-8 px-16",
                      key: phase.id
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["rounded-pill protocol-type me-16", `bg-${phase.protocol.type}`])
                        }, null, 2),
                        _createElementVNode("p", _hoisted_7, _toDisplayString(phase.protocol.name) + " (" + _toDisplayString(phase.name) + ") ", 1),
                        (phase.id === _ctx.phaseSelected)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "icon icon-check-ring-round-light fw-bold text-success",
                              "aria-label": this.$t('Fase seleccionada')
                            }, null, 8, _hoisted_8))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_v_button, {
                          variant: "primary",
                          class: _normalizeClass(["btn-icon fw-normal text-sm px-4 py-4 me-16", {'bg-white text-primary': phase.id === _ctx.phaseSelected}]),
                          "aria-label": _ctx.$t('Seleccionar protocolo'),
                          onClick: ($event: any) => (_ctx.selectPhase(phase.id))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('Seleccionar')), 1),
                            _hoisted_10
                          ]),
                          _: 2
                        }, 1032, ["class", "aria-label", "onClick"])
                      ])
                    ]))
                  }), 128)),
                  (!!_ctx.showAllProtocols)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('Todos los protocolos disponibles:')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.protocols, (protocol) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: protocol.id
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(protocol.phases, (phase) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "container-item d-flex justify-content-between align-items-center text-primary py-8 px-16",
                                key: phase.id
                              }, [
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["rounded-pill protocol-type me-16", `bg-${phase.protocol.type}`])
                                  }, null, 2),
                                  _createElementVNode("p", _hoisted_14, _toDisplayString(phase.protocol.name) + " (" + _toDisplayString(phase.name) + ") ", 1),
                                  (phase.id === _ctx.phaseSelected)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "icon icon-check-ring-round-light fw-bold text-success",
                                        "aria-label": _ctx.$t('Fase seleccionada')
                                      }, null, 8, _hoisted_15))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                  _createVNode(_component_v_button, {
                                    variant: "primary",
                                    class: _normalizeClass(["btn-icon fw-normal text-sm px-4 py-4 me-16", {'bg-white text-primary': phase.id === _ctx.phaseSelected}]),
                                    "aria-label": _ctx.$t('Seleccionar fase'),
                                    onClick: ($event: any) => (_ctx.selectPhase(phase.id))
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('Seleccionar')), 1),
                                      _hoisted_17
                                    ]),
                                    _: 2
                                  }, 1032, ["class", "aria-label", "onClick"])
                                ])
                              ]))
                            }), 128))
                          ], 64))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 64))
        ]),
        _: 1
      }),
      _createVNode(_component_modal_footer, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_button, {
            variant: "link-secondary",
            class: "me-24",
            "data-bs-dismiss": "modal",
            "aria-label": _ctx.$t('Cancelar'),
            onClick: _ctx.closeModal
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Cancelar')), 1)
            ]),
            _: 1
          }, 8, ["aria-label", "onClick"]),
          (_ctx.can('professional.expedient.anamnesis.confirm'))
            ? (_openBlock(), _createBlock(_component_v_button, {
                key: 0,
                variant: "secondary",
                "aria-label": _ctx.$t('Iniciar tratamiento'),
                disabled: !_ctx.meta.valid || _ctx.accepted,
                "is-loading": _ctx.accepted,
                onClick: _ctx.confirmAnamnesisProtocol
              }, {
                default: _withCtx(() => [
                  _hoisted_18,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('Iniciar tratamiento')), 1)
                ]),
                _: 1
              }, 8, ["aria-label", "disabled", "is-loading", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}